import { IconButton, Grid, Grow, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from "@mui/material";
import { CloudUpload, CloudDownload } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { commonSort, getFormDataFromFiles, getSelectedFileNames } from "../../common";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import AddButton from "../../components/AddButton/AddButton";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import FileUploaderPopup from "../../components/Popup/FileUploaderPopup";
import DocumentPopup from "../../components/Popup/DocumentPopup";
import { useTranslation } from "react-i18next";
import { getEqDetailList, deleteEquipment, setEqDetailListEmpty, downloadExcelFile, addEquipmentFiles, getEquipmentFiles, deleteEquipmentFiles } from "../../store/actions/EquipmentAction";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

const ss = sessionStorage;

function Equipment(props) {
    const dispatch = useDispatch();
    let [rows, setRows] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const { t } = useTranslation("translation");

    useEffect(() => {
        LoadHandler();
    }, []);

    const { equipment } = useSelector((state) => state);

    useEffect(() => {
        if (equipment?.eqDetailList?.resultObject) {
            setRows(Object.values(equipment.eqDetailList.resultObject));
            setFilteredItems(Object.values(equipment.eqDetailList.resultObject));
            setPageLoaded(true);
            dispatch(setEqDetailListEmpty());
        }
        if (equipment?.deletedEq?.data) {
            ToggleModal();
            LoadHandler();
        }
        if (equipment?.equipmentFiles) {
            setEquipmentFiles(equipment.equipmentFiles);
            setIsDocumentPopupOpen(true);
            equipment.equipmentFiles = null;
        }
    }, [equipment]);

    const LoadHandler = (filterCleared = false) => {
        const payload = {
            areaId: filterCleared ? 0 : machineStates.selectedAreaCode ?? 0,
            equipmentId: filterCleared ? 0 : machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
        };
        dispatch(getEqDetailList(payload));
    };

    //delete equipment
    const DeleteHandler = (row) => {
        const data = {
            id: row.id,
            code: row.code,
            name: row.name,
            sapCode: row.sapCode,
            barcodeContent: row.barcodeContent,
            brand: row.brand,
            model: row.model,
            warrantyStart: row.warrantyStart,
            warrantyEnd: row.warrantyEnd,
            priority: row.priority,
            mainEquipmentId: row.mainEquipmentId,
            typeId: row.typeId,
            plantId: row.plantId,
            areaId: row.areaId,
            costCenterId: row.costCenterID,
        };
        dispatch(deleteEquipment(data));
    };

    //filter equipment table
    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState([]);

    const searchEquipment = (value) => {
        value = value.toLowerCase();
        let newFilteredItems = rows.filter((item) => item.id?.toString().toLowerCase().includes(value) || item.name?.toLowerCase().includes(value) || item.code?.toLowerCase().includes(value));
        setFilteredItems(newFilteredItems);
    };

    //pagination
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const HandleChangePage = (_event, newPage) => {
        setPage(newPage);
    };
    const HandleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    //edit rows
    const OpenAddUpdatePage = (id) => {
        props.history.push("/editequipment?id=" + id);
    };

    //main equipment can be null
    const SetMainEquipment = (row) => {
        if (row.mainEquipment === null || row.mainEquipment === undefined) {
            return "";
        } else {
            return row.mainEquipment.code;
        }
    };

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const DeleteButtonHandler = (row) => {
        setDeletedRow(row);
        ToggleModal();
    };

    const ToggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const OpenDetailPage = (id) => {
        props.history.push("/addequipmenttogroup?id=" + id);
    };

    //dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const HandleSort = (row, column) => {
        setSortOrder(commonSort(row, column)[0]);
        setSortColumn(commonSort(row, column)[1]);
        setFilteredItems(commonSort(row, column)[2]);
    };

    const HandleApplyFilter = () => {
        LoadHandler();
    };

    const HandleClearFilter = () => {
        HandleClearMachineStates();
        LoadHandler(true);
    };

    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "eq",
            selectedAreaCode: isCleared ? null : ss.getItem("eq_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("eq_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("eq_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("eq_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("eq_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("eq_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);
    const HandleClearMachineStates = () => {
        ss.removeItem("eq_selectedAreaCode");
        ss.removeItem("eq_selectedAreaName");
        ss.removeItem("eq_selectedMainEquipmentCode");
        ss.removeItem("eq_selectedMainEquipmentName");
        ss.removeItem("eq_selectedSubEquipmentCode");
        ss.removeItem("eq_selectedSubEquipmentName");
        setMachineStates(initialMachineStates(true));
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        const directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return (
                    <TableCell id={`eq_rowItems_TableCell_Actions_${index}_${item.id}`} align="center">
                        {t("Actions")}
                    </TableCell>
                );
            } else {
                return isSortingAction ? (
                    <TableCell id={`eq_rowItems_TableCell_${index}_${item.id}`} align="center">
                        <TableSortLabel
                            id={`eq_rowItems_TableSortLabel_${index}_${item.id}`}
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() => HandleSort(rows, item.id)}
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setIsFilterDrawerOpen(open);
    };

    const filter = () => {
        return <DetailFilter setMachineStates={setMachineStates} machineStates={machineStates} />;
    };

    // File Management
    const [equipmentFiles, setEquipmentFiles] = useState([]);
    const [equipmentIdForFileUpload, setEquipmentIdForFileUpload] = useState(0);
    const [equipmentIdForFileDelete, setEquipmentIdForFileDelete] = useState(0);
    const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
    const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);

    const HandleDocumentPopupOpen = (id) => {
        setEquipmentIdForFileDelete(id);
        dispatch(getEquipmentFiles(id));
    };

    const HandleFileUploaderPopupOpen = (id) => {
        setEquipmentIdForFileUpload(id);
        setIsFileUploaderPopupOpen(true);
    };

    const UploadFiles = (files) => {
        const formData = getFormDataFromFiles(files);
        const payload = {
            equipmentId: equipmentIdForFileUpload,
            data: formData,
        };
        dispatch(addEquipmentFiles(payload));
        setIsFileUploaderPopupOpen(false);
    };

    const DeleteEquipmentFile = (selectedFiles) => {
        const selectedFileNames = getSelectedFileNames(selectedFiles);
        const payload = {
            equipmentId: equipmentIdForFileDelete,
            fileNames: selectedFileNames,
        };
        dispatch(deleteEquipmentFiles(payload));
        setIsDocumentPopupOpen(false);
    };

    return (
        <StyledTableDiv>
            <h1>{t("EquipmentList")}</h1>
            <FilterDrawer
                open={isFilterDrawerOpen}
                onOpen={toggleDrawer(true)}
                onClose={toggleDrawer(false)}
                HandleClearFilter={HandleClearFilter}
                HandleApplyFilter={() => {
                    setIsFilterDrawerOpen(false);
                    HandleApplyFilter();
                }}
                downloadExcel={() => dispatch(downloadExcelFile())}
                detailFilter={filter()}
            />
            <FilterButton onClick={() => toggleDrawer(true)} />
            <AddButton onClick={() => OpenAddUpdatePage(0)} />
            {pageLoaded === true ? (
                <React.Fragment>
                    <Grid container spacing={4} alignItems="center" justifyContent="center" sx={{ marginBottom: 4 }}>
                        <Grid item xs={12} sm={12} md={4}>
                            <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => searchEquipment(value)} />
                        </Grid>
                    </Grid>
                </React.Fragment>
            ) : null}
            {rows.length > 0 ? (
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <TableContainer id="eq_TableContainer" component={Paper}>
                        <Table id="eq_Table" aria-label="customized table">
                            <TableHead id="eq_TableHead">
                                <TableRow id="eq_TableRow">
                                    {renderTableCell([
                                        { id: "id", label: "ID" },
                                        { id: "mainEquipment", label: t("MainEquipment") },
                                        { id: "code", label: t("EquipmentCode") },
                                        { id: "detailedCode", label: t("EquipmentDetailCode") },
                                        { id: "name", label: t("EquipmentName") },
                                        { id: "typeCode", label: t("EquipmentType") },
                                        { id: "areaCode", label: t("Area") },
                                        { id: "priority", label: t("Priority") },
                                        { id: "barcodeContent", label: t("EquipmentBarcodeContent") },
                                        { id: "plantCode", label: t("Plant") },
                                        { id: "freeText1", label: t("FreeText") + " 1" },
                                        { id: "freeText2", label: t("FreeText") + " 2" },
                                        { id: "freeText3", label: t("FreeText") + " 3" },
                                        { id: "freeText4", label: t("FreeText") + " 4" },
                                        { id: "Actions", label: t("Actions") },
                                        { id: "UploadFile", label: t("UploadFile") },
                                    ])}
                                </TableRow>
                            </TableHead>
                            <TableBody id="eq_TableBody">
                                {filteredItems.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                    <TableRow id={`eq_TableRow_${index}`} key={row.id}>
                                        <TableCell id={`eq_TableCell_${index}`} align="center">
                                            {row.id}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_1_${index}`} align="center">
                                            {SetMainEquipment(row)}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_2_${index}`} align="center">
                                            {row.code}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_3_${index}`} align="center">
                                            {row.detailedCode}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_4_${index}`} align="center">
                                            {row.name}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_5_${index}`} align="center">
                                            {row.typeCode}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_6_${index}`} align="center">
                                            {row.areaCode}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_7_${index}`} align="center">
                                            {row.priority}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_8_${index}`} align="center">
                                            {row.barcodeContent}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_9_${index}`} align="center">
                                            {row.plantCode}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_10_${index}`} align="center">
                                            {row.freeText1}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_11_${index}`} align="center">
                                            {row.freeText2}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_12_${index}`} align="center">
                                            {row.freeText3}
                                        </TableCell>
                                        <TableCell id={`eq_TableCell_13_${index}`} align="center">
                                            {row.freeText4}
                                        </TableCell>
                                        <TableButtons
                                            row={row}
                                            enableEditHandler={() => OpenAddUpdatePage(row.id)}
                                            deleteButtonHandler={() => DeleteButtonHandler(row)}
                                            openDetailPage={() => OpenDetailPage(row.id)}
                                            detail={true}
                                        />
                                        <TableCell id={`eq_TableCell_14_${index}`} align="center">
                                            <Grid container spacing={1}>
                                                <Grid item xs={12}>
                                                    <Tooltip title={t("UploadFile")}>
                                                        <IconButton id={`eq_TableCell_IconButton_${index}`} onClick={() => HandleFileUploaderPopupOpen(row.id)}>
                                                            <CloudUpload />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Tooltip title={t("ShowFiles")}>
                                                        <IconButton id={`eq_TableCell_IconButton_1_${index}`} onClick={() => HandleDocumentPopupOpen(row.id)}>
                                                            <CloudDownload />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            id="eq_TablePagination"
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={HandleChangePage}
                            onRowsPerPageChange={HandleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}

            <Modal title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => DeleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={ToggleModal} />
            {isFileUploaderPopupOpen ? <FileUploaderPopup isOpen={isFileUploaderPopupOpen} onCancel={() => setIsFileUploaderPopupOpen(false)} onConfirm={UploadFiles} /> : null}
            {isDocumentPopupOpen === true ? (
                <DocumentPopup
                    id="eq_documentPopup"
                    isMaintenanceDocuments={false}
                    isEquipmentDocuments={true}
                    list={[]}
                    equipmentDocuments={equipmentFiles}
                    open={isDocumentPopupOpen}
                    deleteFile={null}
                    deleteEquipmentFiles={DeleteEquipmentFile}
                    close={() => setIsDocumentPopupOpen(false)}
                />
            ) : null}
            <LoadingBackdrop />
        </StyledTableDiv>
    );
}

export default withRouter(Equipment);
